export const MAXIMUM_EMOJI_AMOUNT = 23;
